var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "utilities/outline/Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4571 20.7071C16.8476 20.3166 16.8476 19.6834 16.4571 19.2929L9.16421 12L16.4571 4.70711C16.8476 4.31658 16.8476 3.68342 16.4571 3.2929C16.0666 2.90237 15.4334 2.90237 15.0429 3.2929L7.04289 11.2929C6.85536 11.4804 6.75 11.7348 6.75 12C6.75 12.2652 6.85536 12.5196 7.04289 12.7071L15.0429 20.7071C15.4334 21.0976 16.0666 21.0976 16.4571 20.7071Z",
    fill: "#333D47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.2c437537c99751b0b35fbd6d5607612d.svg";
export { ForwardRef as ReactComponent };